import React, { useState, useRef } from 'react';
import styled from 'styled-components';


import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg';
import MarkunreadIcon from '@mui/icons-material/Markunread';
import LocationOnIcon from '@mui/icons-material/LocationOn';


const ComponentToPrint = React.forwardRef((props, ref) =>{
    
    const [editorText, setEditorText]= useState(props.demand.description);
    const [artisanFirstname, setArtisanFirstname] = useState(props.demand.demand_id);

    //-- gettint the list of all materials
     const materialList =  props.demand.contract.material_list && props.demand.contract.material_list.map((eachMaterial, index) => 
    ({
        id:index, 
        materialName: eachMaterial.material_name,
         materialPrice: eachMaterial.material_price, 
         materialUnit: eachMaterial.material_quantity
    }));

   // ... Calculating the total cost of materials
    const totalMaterialCost = materialList && materialList.reduce((a,c)=> (a+c.materialUnit*c.materialPrice), 0);

    const totalCostToPay = parseFloat(totalMaterialCost) + parseFloat(props.demand.contract.wage) ;


    

    return (


                <Content ref={ref}>
                    <HeaderLogo >
                    <h1 >LE PETIT BOULOT</h1>
                    </HeaderLogo>
                    <Header>
                    <h2>Informations sur le contrat final pour {props.demand.user_firstname}</h2>
                    </Header>
                    <SharedContent>
                        
                    <h2 style={{textAlign: 'center'}}>L'Artisan / Le Client</h2>
                    <Users>
                        <UserAddresses>
                            <ArtisanInfo>

                            {props.demand.contract&& props.demand.contract.artisan_profile_image ? <img src={props.demand.contract.artisan_profile_image}/>
                            :
                            <img src="/images/user.svg" alt="" />
                            }
                            <span>{props.demand.contract.artisan_firstname}</span>

                            </ArtisanInfo>
                            <AddressAndPhone>
                                    <PermPhoneMsgIcon/>
                                    <Address>{ props.demand.contract.artisan_phone_number}</Address>
                            </AddressAndPhone>
                            <AddressAndPhone>
                                    <MarkunreadIcon/>
                                    <Address>{props.demand.contract.artisan_email}</Address>
                            </AddressAndPhone>
                            <AddressAndPhone>
                                    <LocationOnIcon/>
                                    <Address>{props.demand.contract.artisan_address}</Address>
                            </AddressAndPhone>
                        </UserAddresses>

                        {/* client */}
                        <UserAddresses>
                            <ClientInfo>
                                {props.demand.contract && props.demand.client_profile_image?
                                    <img src={props.demand.client_profile_image}/>
                                :<img src="/images/user.svg" alt="" />
                                }
                                <span>{props.demand.user_firstname}</span>
                            </ClientInfo>
                            <AddressAndPhone>
                                    <PermPhoneMsgIcon/> 
                                    <Address>{ props.demand.client_phone_number}</Address>
                            </AddressAndPhone>

                            <AddressAndPhone>
                                    <MarkunreadIcon/>
                                    <Address>{props.demand.user_email_address}</Address>
                            </AddressAndPhone>
                            
                            {props.demand.demand_address === props.demand.client_address ?
                            <AddressAndPhone>
                            <LocationOnIcon/>
                            <Address>{props.demand.demand_address}</Address>
                            </AddressAndPhone>
                            
                            :
                            <div>
                            <AddressAndPhone>
                            <LocationOnIcon/>
                            <Address>Adresse du chantier :  {props.demand.demand_address}</Address>
                            </AddressAndPhone>
                            <AddressAndPhone>
                            <LocationOnIcon/> 
                            <Address>Adresse client/facturation : {props.demand.demand_address}</Address>
                            </AddressAndPhone>
                            </div>
                            }
                            
                        </UserAddresses>
                    </Users>                                
                        
                    <Editor>
                        <label id='contractDetails'>Description de la demande / ID de référence : {props.demand.demand_id}</label>
                        {props.demand.contract &&
                        <textarea value={editorText} ></textarea> 
                        }   
                        
                        <label id='artisanDetails'>Description du problème par l'artisan</label>
                        {props.demand.contract &&
                        <textarea value={props.demand.contract.description} ></textarea> 
                        }             

                        <ContractDetails> 

                        <Table>
                            <table>
                            <thead>
                                <th >Détails</th>
                                <th>Quantité</th>
                                <th >Prix ​​unitaire</th>
                                <th >Totale €</th>
                            </thead>
                            <tbody>
                            {props.demand.contract.material_list?  props.demand.contract.material_list.map((eachMaterial, key)=> (                            
                                <tr key={key}>
                                <td >Matériaux utilisés: {eachMaterial.material_name}</td>
                                <td>{eachMaterial.material_quantity}</td>
                                <td>{eachMaterial.material_price}</td>
                                <td>{eachMaterial.material_price* eachMaterial.material_quantity}</td>
                                </tr>
                            ))
                            :null}
                            </tbody>
                            
                            <tbody>
                                <tr>
                                <td>Wage: </td>
                                <td>---</td>
                                <td>---</td>
                                <td>{props.demand.contract.wage}</td>
                                </tr>
                            </tbody>
                            </table>   
                        </Table>

                        </ContractDetails>
                                            
                       

                        <label style={{fontWeight:'600'}} id='materialCost'>Total Cost: €</label>
                        
                        <input style={{fontWeight:'600', padding:'5px'}} value={totalCostToPay}  />
                        
                        <h4>Projet mis en ligne le :  </h4> {props.demand.date.toDate().toLocaleDateString()}

                        <h4>Projet terminé à</h4> {props.demand.contract.end_date.toDate().toLocaleDateString()}
                    </Editor>
                    
                    <Footer>
                        <h4>Le Petit Boulot</h4>
                        <CompanyAddress>
                        73 Rue Rabaneau, 33 440 Ambarès
                        <h5>
                        support@lepetitboulot.fr
                        </h5>
                        
                        </CompanyAddress>
                    </Footer>

                    </SharedContent>                    
                </Content>
 
            
        );
});



const Content = styled.div`
    width:90%;
    background-color:white;
    max-height:100%;
    overflow:initial;
    border-radius:5px;
    position: relative;
    display:flex;
    flex-direction:column;
    top:32px;
    margin: 0 auto;
`;

const Header = styled.div`
    display:block;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(0,0,0, 0.15);
    font-size:16px;
    line-height: 1.5;
    color: rgba(0,0,0,0.6);
    font-weight: 400;
    display: flex;
    align-items:center;
    button{
        height:40px;
        width:40px;
        min-width:auto;
        color: rgba(0,0,0,0.15);
        background-color:transparent;
        border: none;
        justify-content: center;
        cursor: pointer;
        &:hover{
            border-radius:50%;
            background-color: #aaa;
        }
        
    }
    h2{
        text-align: center;
    }
    img{
        width:40px;
        margin-bottom:3px;
    }
`;

const HeaderLogo = styled(Header)`
    justify-content:center;
    background-color:#111111;
    border-radius: 5px;
    color:#c0a375;
    h1{
        font-weight:'700'
    }
    `;

const SharedContent = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow:1;
    overflow-y:auto;
    vertical-align: baseline;
    background: transparent;
    padding: 8px 12px;
`;


const Users = styled.div`
    display: flex;
    flex-direction: row;
    flex-flow: row wrap;
    text-align: left; 
    justify-content: space-around;
    margin-bottom:10px;
    border-bottom: 1px solid rgba(0,0,0, 0.15);
    padding-bottom: 10px;
`;



const ArtisanInfo = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 12px;

    svg, img{
        width: 48px;
        height:48px;
        background-clip: content-box;
        border: 2px solid transparent;
        border-radius: 50%;
    }
    span{
        font-weight: 600;
        font-size: 16px;
        line-height: 1.5;
        margin-left: 5px;
    }
`;

const UserAddresses = styled.div`
    display: flex;
    flex-direction: column;
`;

const AddressAndPhone = styled.div`
    display: flex;
    flex-direction:row;
`;

const Address = styled.span`
    display: flex;
    flex-direction: row;
    margin-left:10px;
`;
const ClientInfo = styled(ArtisanInfo)`
`;


const Editor = styled.div`
    padding: 12px 24px;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right:auto;
    width:80%;

    textarea{
        width: 100%;
        min-height: 100px;
        resize: none;
    }

    input{
        width: 100%;
        height: 35px;
        font-size: 16px;
        margin-bottom: 20px;
    }
`;

const ContractDetails =styled.div`
    display:flex;
    justify-content:center;
    width:100%;
`;

const Table = styled.div`
    display:flex;
    table-layout: fixed;
    width: 100%;
    align-items: stretch;
    justify-content: center;
    align-items: center;
    border-collapse:collapse;
    border-spacing:0;
    padding:20px;
    
    td{
        border-color:black;
        border-style:solid;
        border-width:1px;
        border-radius:10px;
        overflow:hidden;
        padding:10px 5px;
        word-break:normal;
    }
    th{
        border-color:black;
        border-style:solid;
        border-width:1px;
        font-weight:normal;
        overflow:hidden;
        padding:10px 5px;
        word-break:normal;
        font-weight:bold;
        text-align:center;
        vertical-align:top
    }
    @media(max-width: 767px) {
        td {width: auto !important;
            width: auto !important;
            overflow-x: auto;-webkit-overflow-scrolling: touch;margin: auto 0px;}}
`;

const Footer  = styled.div`
    border-top: 1px solid rgba(0,0,0, 0.15);
    justify-content: center;
    text-align: center;
    align-items: center;
    width: 100%;
    position: absolute;
    bottom: 0;
    left:0;
    display:none;
`;

const CompanyAddress=styled.div``;


export default ComponentToPrint;